import React from "react";

import("~/less/specials.less");

const OutletHeadingLabel = () => (
  <div
    className="header-specials small-header outlet-special box"
    data-testid="outlet-heading-label"
    style={{ height: "60px" }}
  >
    <a href="/outlet.html" className="header-logo">
      {" "}
    </a>
    <p className="now-viewing">
      You are viewing a product from WebstaurantStore Outlet.
    </p>
  </div>
);

export default OutletHeadingLabel;
